import React from 'react';
import styled from 'styled-components';
import ArrowBack from '@material-ui/icons/ArrowBack';

const HeaderContainer = styled.div`
  background: #37474f;
  display: flex;
  justify-content: space-between;
  padding: 10px 95px;
  @media screen and (max-width: 1560px) {
    padding: 10px 35px;
  }
`;

const HeadingContainer = styled.div`
  margin-left: 1rem;
  height: 3.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const Title = styled.h2`
  color: #fff;
  font-size: 1.5rem;
`;

const Wrapper = styled.div`
  display: flex;
`;
const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  color: white;
  &:first-child {
    cursor: pointer;
  }
`;

const Header = ({ history }) => (
  <HeaderContainer>
    <Wrapper>
      <ArrowWrapper>
        <ArrowBack onClick={history.goBack} />
      </ArrowWrapper>

      <HeadingContainer>
        <Title>Internal Search</Title>
      </HeadingContainer>
    </Wrapper>
  </HeaderContainer>
);

export default Header;
